/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { CostUnit } from '../models/CostUnit';

export class Cost {
  /**
  * Cost amount in the specified currency unit. 1 credit is equivalent to 0.01 USD. 
  */
  'amount': number;
  'unit': CostUnit;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "amount",
      "baseName": "amount",
      "type": "number",
      "format": "double"
    },
    {
      "name": "unit",
      "baseName": "unit",
      "type": "CostUnit",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return Cost.attributeTypeMap;
  }

  public constructor() {
  }
}



